// extracted by mini-css-extract-plugin
module.exports = {"image":"SimpleCardBlock_image__p7Vgp"};